"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoPreview = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const helper_1 = require("./helper");
const VideoPreview = ({ url }) => {
    if (!url) {
        return null;
    }
    const id = helper_1.getVideoId(url);
    if (id) {
        return (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement("iframe", { src: `https://www.youtube.com/embed/${id}`, frameBorder: "0", allow: "autoplay; encrypted-media", allowFullScreen: true })));
    }
    return null;
};
exports.VideoPreview = VideoPreview;
